import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form } from 'informed';
import { get } from 'lodash';
import { Spinner } from '../elements';
import { GUARANTEE_TYPE } from '../../lib/config';
import {
  validateFinanceData, fetchFinanceData, fetchFinancePlans, fetchPaymentPlans,
} from '../services/finance_data_service';
import ComponentWithToken from '../components/CompontentWithToken';
import FinancePlansForm from '../components/FinancePlansForm';
import GuaranteeTypeForm from '../components/GuaranteeTypeForm';
import {
  fetchGuaranteeTypes, fetchDocumentTypes, fetchMaritalPropertySystems, fetchMaritalStatuses, fetchNationalities,
} from '../services/options_service';
import LetterGuaranteeForm from '../components/LetterGuaranteeForm';
import GuarantorForm from '../components/GuarantorForm';
import StepControllerButtons from '../components/StepControllerButtons';
import FinanceOfficerForm from '../components/FinanceOfficerForm';
import EditingButtons from '../components/common/EditingButtons';


class FinanceDataForm extends ComponentWithToken {
  previousErrors = {};


  getChangePlanMessage = () => (
    <>
      <p>O plano de pagamento no vencimento escolhido anteriormente não está mais disponível. Gentileza escolher novamente o plano desejado com nova data de vencimento.</p>
      <p>Caso você tenha realizado o pagamento, gentileza encaminhar comprovante de pagamento para o e-mail financeiro@feluma.org.br.</p>
    </>
  )

  state = {
    loading: true,
    loadingPayments: true,
    form: {},
    financeData: {},
    financePlans: [],
    documentTypes: [],
    paymentPlans: [],
    maritalStatuses: [],
    maritalPropertySystems: [],
    guaranteeTypes: [],
    nationalities: [],
    financeOfficer: {},
    errors: {},
    changePlanRequested: false,
    showFinanceOfficer: false,
  };

  componentDidMount() {
    Promise.all(
      [
        this.fetchOptions(),
        this.fetchFinanceData(),
      ],
    ).then(() => this.setState({ loading: false }));
  }

  fetchFinanceData = () => fetchFinanceData(this.token).then((response) => {
    this.formApi.setValues(response);
    this.setState({
      changePlanRequested: response.change_plan_requested,
      showFinanceOfficer: response.show_finance_officer,
      financeOfficer: response.finance_officer,
    });
  }).catch(() => this.setState({ loading: false }));

  fetchOptions = () => {
    const options = [
      {
        field: 'financePlans',
        fetchFunction: fetchFinancePlans,
      },
      {
        field: 'paymentPlans',
        fetchFunction: fetchPaymentPlans,
      },
      {
        field: 'guaranteeTypes',
        fetchFunction: fetchGuaranteeTypes,
      },
      {
        field: 'documentTypes',
        fetchFunction: fetchDocumentTypes,
      },
      {
        field: 'maritalPropertySystems',
        fetchFunction: fetchMaritalPropertySystems,
      },
      {
        field: 'maritalStatuses',
        fetchFunction: fetchMaritalStatuses,
      },
      {
        field: 'nationalities',
        fetchFunction: fetchNationalities,
      },
    ];
    this.setState({ loadingOptions: true });
    return Promise.all([
      options.map(option => option.fetchFunction(this.token).then(response => this.setState({
        [option.field]: response,
      }))),
    ]).then(() => this.setState({ loadingOptions: false }));
  };


  validateFinanceData = () => {
    this.setState({ loading: true });
    const { onClick } = this.props;
    let { values } = this.formApi.getState();

    const { financePlans, changePlanRequested, showFinanceOfficer } = this.state;
    const shouldSendFinanceOfficer = showFinanceOfficer;

    if (!shouldSendFinanceOfficer) {
      values.finance_officer = undefined;
    }

    const financePlan = financePlans.find(f => f.id === values.plan);
    if (financePlan) {
      values = {
        ...values,
        guarantors: (get(values, 'guarantors') || []).filter((_, i) => i < financePlan.guarantors),
      };
    }

    validateFinanceData(this.token, values)
      .then(() => {
        this.setState({ loading: false });
        if (changePlanRequested) {
          window.location.reload();
        } else {
          onClick();
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        const status = get(error, 'response.status');
        if (status === 400) {
          const errors = get(error, 'response.data');
          this.setState({ errors });
          Object.keys(this.previousErrors).forEach((fieldName) => {
            if (this.formApi.fieldExists(fieldName)) {
              this.formApi.setError(fieldName, null);
            }
          });
          this.previousErrors = { ...errors };

          const { guarantors } = errors;

          Object.entries(errors).forEach((e) => {
            if (this.formApi.fieldExists(e[0])) {
              this.formApi.setError(e[0], e[1]);
            }
          });

          if (Array.isArray(guarantors)) {
            guarantors.forEach((gErrors, i) => {
              Object.entries(gErrors).forEach((e) => {
                const fieldName = `guarantors[${i}].${e[0]}`;
                if (this.formApi.fieldExists(fieldName)) {
                  this.formApi.setError(fieldName, e[1]);
                }
              });
            });
          }
        }
      });
  }

  shouldShowGuarantee = () => {
    const { financePlans } = this.state;
    const plan = this.formApi ? this.formApi.getValue('plan') : undefined;
    const selectedPlan = financePlans.find(financePlan => financePlan.id === plan);
    return selectedPlan ? +selectedPlan.guarantors > 0 : false;
  }

  onChangeFinanceOfficer = (field, value) => {
    this.setState(prevState => ({
      ...prevState,
      financeOfficer: {
        ...prevState.financeOfficer,
        [field]: value,
      }
    }))
  }

  render() {
    const {
      loading,
      loadingOptions,
      financePlans,
      paymentPlans,
      guaranteeTypes,
      nationalities,
      maritalStatuses,
      maritalPropertySystems,
      documentTypes,
      changePlanRequested,
      showFinanceOfficer,
      financeOfficer,
    } = this.state;

    const { backClick, onEdit, isEditing } = this.props;

    return (
      <>
        <Spinner active={loading || loadingOptions}>
          <Form
            onValueChange={form => this.setState({ form })}
            getApi={(api) => { this.formApi = api; }}
            initialValues={{ guarantors: [] }}
          >
            {({ formApi }) => (
              <>
                {changePlanRequested && this.getChangePlanMessage()}
                <FinancePlansForm financePlans={financePlans} paymentPlans={paymentPlans} loadingOptions={loadingOptions} />
                {this.shouldShowGuarantee() && (
                  <>
                    <GuaranteeTypeForm guaranteeTypes={guaranteeTypes} />
                    { formApi.getValue('guarantee_type') === GUARANTEE_TYPE.LETTER_GUARANTEE && <LetterGuaranteeForm />}
                    { formApi.getValue('guarantee_type') === GUARANTEE_TYPE.GUARANTOR && (
                      <GuarantorForm
                        financePlans={financePlans}
                        nationalities={nationalities}
                        maritalStatuses={maritalStatuses}
                        maritalPropertySystems={maritalPropertySystems}
                        documentTypes={documentTypes}
                      />
                    )}
                  </>
                )}
                {showFinanceOfficer && (
                  <FinanceOfficerForm
                    onChange={this.onChangeFinanceOfficer}
                    financeOfficer={financeOfficer}
                  />
                )}
                {
                  !isEditing && (
                    <>
                      <hr />
                      <StepControllerButtons onBackClick={backClick} onFowardClick={this.validateFinanceData} />
                    </>
                  )
                }
              </>
            )}
          </Form>
        </Spinner>
        {
          isEditing && <EditingButtons onEdit={onEdit} loading={loading} onSubmit={this.validateFinanceData} />
        }
      </>
    );
  }
}

export default withRouter(FinanceDataForm);
